import AccountDetailLayout from "layout/account-detail-layout/AccountDetailLayout";

const Projects = () => {
  return (
    <AccountDetailLayout>
      <div className="min-h-[calc(100vh-120px)]">
        <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm ">Projects</h1>
        <p className="text-muted-foreground lg:text-md md:text-sm text-[13px]">Efficiently Plan, Track, and Execute Projects & Tasks</p>
      </div>
    </AccountDetailLayout>
  );
};

export default Projects;
